import { AnimationWithSize } from './AnimationWithSize';

export const Page = () => (
	<AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/38q0358viy2mcd14c3tvx2s437634r53.riv" />
);
